import React from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { TextField } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField/TextField';

type TextFieldOutlinedProps = TextFieldProps & {
    noHelperText?: boolean;
    rounded?: boolean;
};

export const TextFieldOutlined: React.FC<TextFieldOutlinedProps> = ({
    className,
    fullWidth = true,
    helperText = ' ',
    noHelperText,
    rounded = true,
    ...props
}) => {
    return (
        <TextField
            {...props}
            fullWidth={fullWidth}
            className={classNames(css.module, className, rounded && css.rounded)}
            variant="outlined"
            helperText={noHelperText ? undefined : helperText}
            InputLabelProps={{ shrink: true, ...props.InputLabelProps }}
        />
    );
};
